<app-solutions-header-banner></app-solutions-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center mt-20">
  <h2 class="font-bold text-3xl website-heading">Automotive</h2>
  <span class="font-light text-2xl website-light-heading">The All-In-One Connected Vehicle Platform</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Delivering great digital experiences to customers is a
    must in today's world and automotive OEMs are increasingly facing the digital world where they are forced to deliver
    on many new approaches like SDV, OTA updates, and Electric vehicles driving them to explore various directions and
    deliver numerous connected experiences through their vehicle platforms.</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">However, currently, these capabilities are restricted to
    a select few vehicles within their lineup, which limits the potential impact of a unified connected platform for
    delivering value and engaging their customers. Furthermore, connected vehicles typically offer use cases that are
    confined to the vehicle itself.</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Varroc Connect automotive cloud platform can play a role
    of delivering unified and uniform digital experiences to all your customers whether they are your old installed base
    customers or the new ones.</span>

  <div class="flex flex-col items-start gap-6 mt-5 w-full">
    <div class="flex items-start md:items-center gap-5">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span class="text-l text-justify w-full color-[#0A0A0A]">Our platform can seamlessly integrate with your
        existing infrastructure, filling in the gaps to enhance the overall customer experience. Alternatively, we offer
        end-to-end implementation, including a range of telematics hardware options from the Varroc Connect
        portfolio.</span>
    </div>

    <div class="flex items-start md:items-center gap-5">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span class="text-l text-justify w-full  color-[#0A0A0A]">We can assist you in elevating the digital customer
        experience to Level 3, encompassing vehicle, driver, and ecosystem-related interactions.</span>
    </div>

    <div class="flex items-start md:items-center gap-5">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span class="text-l text-justify w-full color-[#0A0A0A]">The customer's aim for holistic value can be
        delivered through comprehensive use cases, achievable with Level 3 customer experiences.</span>
    </div>

    <div class="flex items-start md:items-center gap-5">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span class="text-l text-justify w-full color-[#0A0A0A]">Our portfolio of Apps, Cloud, Hardware, and services
        can be utilized as a complete package or in modular components that seamlessly integrate with and enhance the
        existing platform architecture of OEMs, customized to their specific requirements and stages of
        development.</span>
    </div>

  </div>

  <div class="flex flex-col mt-10 gap-10  md:mt-20 md:gap-20 items-center justify-center">
    <img [src]="Images.SOLUTION_AUTOMOTIVE_BANNER" alt="Varroc Connect Automotive Smart Solutions" class="w-[80%]">
  </div>

</div>